import TableDriverViewSessionHistory from '../../components/drivers/TableDriverViewSessionHistory'
import { connect } from 'react-redux'
import {
  getDriverCheckInCheckOut,
  deleteDriverSession,
  getDriverSessionListV2,
  getDriverSessionListPerDate,
  getManyTripsPerOperatorV2
} from '../../state/actions/drivers'
import {
  IStoreState,
  IDriverSessionFilters,
  IDriverSessionHistoryFilters,
  IDriverDeleteSessionObject
} from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  return {
    ownProps,
    currentOrganizationId: state.organizations.currentOrgId,
    sessionHistory: convertToArray(state.drivers.sessionHistory),
    isFetching: state.drivers.sessionRequest,
    error: state.drivers.sessionError,
    totalSessions: state.drivers.totalSessions
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getDriversSessionList: (filters: IDriverSessionFilters) => dispatch(getDriverSessionListV2(filters)),
    getCheckInCheckOut: (filters: IDriverSessionHistoryFilters) => {
      return getDriverCheckInCheckOut(filters)
    },
    getDriverSessionListPerDate: (date: string, operatorId: string): Promise<any> => {
      return getDriverSessionListPerDate({ date, operatorId })
    },
    getManyTripsPerOperator: (filters: IDriverSessionHistoryFilters) => {
      return getManyTripsPerOperatorV2(filters)
    },
    deleteSession: async (dto: IDriverDeleteSessionObject) => {
      return await dispatch(deleteDriverSession(dto))
    }
  }
}

function convertToArray(sessionHistory: any) {
  const historyValues: any[] = Object.values(sessionHistory)

  return historyValues
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableDriverViewSessionHistory)



// WEBPACK FOOTER //
// ./src/containers/drivers/TableDriverViewSessionHistory.ts